recreateRef